import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';

import PicturePanel from './picturePanel';
import DescriptionPanel from './descriptionPanel';
import './productPanel.css'

class ProductPanel extends Component {
    render() {
    	let imgURL = this.props.imgURL;
    	let desc = this.props.desc;

    	return(
	      <div className="ProductPanel container">
          <Row className="show-grid">
            <Col md={6} sm={6} xs={12}>
              <PicturePanel dynamicClass="" imgURL={imgURL}/>
            </Col>
            <Col md={6} sm={6} xs={12}>
              <DescriptionPanel dynamicClass="" desc={desc} />
            </Col>
          </Row>
	      </div>
	    );
    }
}

export default ProductPanel;



// WEBPACK FOOTER //
// ./src/components/singleItem/productPanel.js